import React, { Component } from "react";
import SvgSpinner from "../SvgSpinner/SvgSpinner";

import "./Spinner.scss";

class Spinner extends Component {
  render() {
    return (
      <div className="spinner">
        <SvgSpinner />
      </div>
    );
  }
}

export default Spinner;